// Delivery Date Picker — Prime Flowers
// Una fecha de entrega se ofrece solo si el DÍA DE DESPACHO que exige todavía es
// alcanzable según el corte de preparación.
// Dos calendarios de festivos, y bloquean cosas distintas:
//   Colombia → bloquea el DESPACHO (la finca no trabaja)
//   USA      → bloquea la ENTREGA  (FedEx no reparte)
// Además, cupo diario por fecha vía Supabase.

const SUPABASE_URL  = 'https://szzlcsuszgideotjzlsx.supabase.co';
const SUPABASE_KEY  = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InN6emxjc3VzemdpZGVvdGp6bHN4Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzczMTE1NTcsImV4cCI6MjA5Mjg4NzU1N30.wNLvyrDa4AkAXBrSntBesOQ-LNydLxEnIoeu0EATbSk';
const DEFAULT_MAX   = 30;
const HORIZON_DAYS  = 90;

// IPD 48H Colombia — día de despacho → días hasta la entrega en USA.
// Fuente: FedEx Flowers Team Presentation, pág. 4 (jun 2026).
//   Lunes → Miércoles · Martes → Jueves · Miércoles → Viernes
//   Viernes → Lunes   · Sábado → Martes
// Jueves (4) y Domingo (0) NO están en el programa: no aparecen acá a propósito.
const SHIP_TO_DELIVERY = {
  1: 2,  // Lun → Mié
  2: 2,  // Mar → Jue
  3: 2,  // Mié → Vie
  5: 3,  // Vie → Lun
  6: 3,  // Sáb → Mar
};

// Excepciones por FECHA de despacho, cuando FedEx corre la entrega por un festivo
// de USA y la tabla semanal deja de aplicar.
// Fuente: correo de Rafael Hurtado (FedEx) "Labor Day Schedule 2026 Colombia &
// Ecuador", 3 ago 2026 — tabla COLOMBIA IPD 48 HOURS.
//   sáb 5 sep 2026: la tabla diría martes 8, FedEx entrega el MIÉRCOLES 9 (+1 día).
// Sin esto el picker le vende al cliente una fecha que FedEx no cumple.
const SHIP_OFFSET_EXCEPTIONS = {
  '2026-09-05': 4,   // sáb 5 sep → mié 9 sep (Labor Day)
};

// Hasta cuándo puede entrar un pedido para alcanzar cada día de despacho.
// Todo se evalúa en HORA DE COLOMBIA, no en la del navegador del cliente.
//
// Entre semana el corte es a las 10:00 del mismo día: deja tres horas para
// preparar las cajas antes del límite de reserva de carga de FedEx MDE (13:00).
// El sábado el corte es el viernes a las 14:00, porque el turno hay que planearlo
// con un día de antelación.
const CUTOFFS = {
  1: { daysBefore: 0, hour: 10 },
  2: { daysBefore: 0, hour: 10 },
  3: { daysBefore: 0, hour: 10 },
  5: { daysBefore: 0, hour: 10 },
  6: { daysBefore: 1, hour: 14 },  // viernes 2 p.m.
};

// Festivos de USA: bloquean el día de ENTREGA (FedEx no reparte).
const HOLIDAYS = new Set();
// Festivos de Colombia: bloquean el día de DESPACHO (la finca no trabaja).
const CO_HOLIDAYS = new Set();
// Fechas llenas cargadas de Supabase
const FULL_DATES = new Set();
let capacityLoaded = false;

function toDateStr(d) {
  return `${d.getFullYear()}-${String(d.getMonth()+1).padStart(2,'0')}-${String(d.getDate()).padStart(2,'0')}`;
}

// El cliente puede estar en cualquier huso de USA. Un pedido a las 9:00 en
// California son las 11:00 en Colombia y el corte ya pasó, así que la hora
// siempre se resuelve contra America/Bogota.
function nowInBogota() {
  return new Date(new Date().toLocaleString('en-US', { timeZone: 'America/Bogota' }));
}

function lastWeekdayOfMonth(year, month, weekday) {
  const d = new Date(year, month + 1, 0);
  while (d.getDay() !== weekday) d.setDate(d.getDate() - 1);
  return d;
}
function nthWeekdayOfMonth(year, month, weekday, n) {
  const d = new Date(year, month, 1);
  while (d.getDay() !== weekday) d.setDate(d.getDate() + 1);
  d.setDate(d.getDate() + (n - 1) * 7);
  return d;
}
function buildHolidays(year) {
  // Solo los días en que FedEx Express NO reparte.
  // Fuera de esta lista a propósito (10 ago 2026): Veterans Day (11-11),
  // Nochebuena (12-24) y 31 de diciembre. FedEx sí opera esos días y
  // bloquearlos costaba ventas en temporada alta.
  for (const mmdd of ['01-01','06-19','07-04','12-25'])
    HOLIDAYS.add(`${year}-${mmdd}`);
  HOLIDAYS.add(toDateStr(lastWeekdayOfMonth(year, 4, 1)));
  HOLIDAYS.add(toDateStr(nthWeekdayOfMonth(year, 8, 1, 1)));
  const tg = nthWeekdayOfMonth(year, 10, 4, 4);
  HOLIDAYS.add(toDateStr(tg));
  const tgNext = new Date(tg); tgNext.setDate(tg.getDate()+1);
  HOLIDAYS.add(toDateStr(tgNext));
}
// ── Festivos de Colombia ───────────────────────────────────────────────────
// Bloquean el DESPACHO, no la entrega: la finca no trabaja y no hay quien
// prepare ni lleve la carga a la terminal.
function addDays(d, n) { const r = new Date(d); r.setDate(d.getDate() + n); return r; }

// Ley Emiliani: varios festivos se corren al lunes siguiente.
function toMonday(d) { return addDays(d, (1 - d.getDay() + 7) % 7); }

// Domingo de Pascua (Meeus/Jones/Butcher). De él salen 5 festivos móviles.
function easterSunday(y) {
  const a = y % 19, b = Math.floor(y/100), c = y % 100;
  const d = Math.floor(b/4), e = b % 4, f = Math.floor((b+8)/25);
  const g = Math.floor((b-f+1)/3), h = (19*a + b - d - g + 15) % 30;
  const i = Math.floor(c/4), k = c % 4;
  const l = (32 + 2*e + 2*i - h - k) % 7;
  const m = Math.floor((a + 11*h + 22*l) / 451);
  const month = Math.floor((h + l - 7*m + 114) / 31);
  const day   = ((h + l - 7*m + 114) % 31) + 1;
  return new Date(y, month - 1, day);
}

function buildCOHolidays(y) {
  // Fijos: Año Nuevo, Trabajo, Independencia, Boyacá, Inmaculada, Navidad
  [[0,1],[4,1],[6,20],[7,7],[11,8],[11,25]]
    .forEach(([m,d]) => CO_HOLIDAYS.add(toDateStr(new Date(y,m,d))));
  // Corridos al lunes: Reyes, San José, San Pedro, Asunción, Raza, Todos los Santos, Cartagena
  [[0,6],[2,19],[5,29],[7,15],[9,12],[10,1],[10,11]]
    .forEach(([m,d]) => CO_HOLIDAYS.add(toDateStr(toMonday(new Date(y,m,d)))));
  // Móviles de Semana Santa
  const p = easterSunday(y);
  CO_HOLIDAYS.add(toDateStr(addDays(p,-3)));   // Jueves Santo
  CO_HOLIDAYS.add(toDateStr(addDays(p,-2)));   // Viernes Santo
  [43,64,71].forEach(off =>                    // Ascensión, Corpus Christi, Sagrado Corazón
    CO_HOLIDAYS.add(toDateStr(toMonday(addDays(p,off)))));
}

const thisYear = nowInBogota().getFullYear();
buildHolidays(thisYear);
buildHolidays(thisYear + 1);
buildCOHolidays(thisYear);
buildCOHolidays(thisYear + 1);

// Carga disponibilidad de Supabase (delivery_bookings + delivery_capacity)
async function loadCapacity() {
  try {
    const res = await fetch(
      `${SUPABASE_URL}/rest/v1/delivery_bookings?select=delivery_date,booked`,
      { headers: { apikey: SUPABASE_KEY, Authorization: `Bearer ${SUPABASE_KEY}` } }
    );
    const rows = await res.json();
    // También cargar capacidades personalizadas
    const res2 = await fetch(
      `${SUPABASE_URL}/rest/v1/delivery_capacity?select=delivery_date,max_boxes`,
      { headers: { apikey: SUPABASE_KEY, Authorization: `Bearer ${SUPABASE_KEY}` } }
    );
    const caps = await res2.json();
    const capMap = {};
    if (Array.isArray(caps)) caps.forEach(r => { capMap[r.delivery_date] = r.max_boxes; });
    if (Array.isArray(rows)) {
      rows.forEach(r => {
        const max = capMap[r.delivery_date] ?? DEFAULT_MAX;
        if (r.booked >= max) FULL_DATES.add(r.delivery_date);
      });
    }
  } catch(e) { /* Si falla Supabase, no bloqueamos fechas por capacidad */ }
  capacityLoaded = true;
}

// Recorre los próximos HORIZON_DAYS días de despacho y se queda con los que
// todavía alcanzan su corte. Devuelve Map: fecha de entrega → fecha de despacho.
// Se recalcula en cada validación: una pestaña abierta desde antes de las 10:00
// no puede seguir ofreciendo el despacho de hoy después del corte.
function buildFeasibleDeliveries() {
  const feasible = new Map();
  const now = nowInBogota();
  const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());

  for (let i = 0; i <= HORIZON_DAYS; i++) {
    const ship = new Date(today);
    ship.setDate(today.getDate() + i);

    const shipStr = toDateStr(ship);
    let offset = SHIP_TO_DELIVERY[ship.getDay()];
    if (offset === undefined) continue;           // jueves y domingo no operan
    if (SHIP_OFFSET_EXCEPTIONS[shipStr] !== undefined) {
      offset = SHIP_OFFSET_EXCEPTIONS[shipStr];   // festivo USA: FedEx corre la entrega
    }
    if (CO_HOLIDAYS.has(shipStr)) continue;       // festivo en Colombia: no se despacha

    const cutoff   = CUTOFFS[ship.getDay()];
    const deadline = new Date(ship);
    deadline.setDate(ship.getDate() - cutoff.daysBefore);
    deadline.setHours(cutoff.hour, 0, 0, 0);
    if (now > deadline) continue;                 // ese despacho ya no se alcanza

    const delivery = new Date(ship);
    delivery.setDate(ship.getDate() + offset);
    const dstr = toDateStr(delivery);

    if (HOLIDAYS.has(dstr)) continue;             // festivo USA: no hay reparto
    if (FULL_DATES.has(dstr)) continue;           // cupo del día lleno

    // Se sobrescribe a propósito: el bucle va hacia adelante, así que gana el
    // despacho MÁS TARDÍO que alcanza esa entrega — corte más tarde para el
    // cliente y flor más fresca. Sin excepciones cada entrega tiene un solo
    // despacho posible y esto no cambia nada; con una excepción (mié 9 sep, que
    // alcanzan tanto el sáb 5 como el lun 7) evita cerrar la venta el viernes
    // a las 2 p.m. cuando en realidad hay plazo hasta el lunes a las 10.
    feasible.set(dstr, shipStr);
  }
  return feasible;
}

function formatDateFriendly(dateStr) {
  return new Date(dateStr + 'T12:00:00').toLocaleDateString('en-US',
    { weekday:'long', month:'long', day:'numeric', year:'numeric' });
}

function formatOption(dateStr) {
  return new Date(dateStr + 'T12:00:00').toLocaleDateString('en-US',
    { weekday:'long', month:'short', day:'numeric' });
}

// Cuántas fechas se listan: unas seis semanas. Más es una lista eterna en el celular.
const MAX_OPTIONS = 30;

// El campo es un <select> con solo las fechas que se pueden entregar (28 oct 2026).
// Antes era <input type="date">: en el iPhone salía como un cuadro vacío y el
// calendario dejaba escoger cualquier día para después rechazarlo en rojo.
function fillOptions(select, feasible) {
  const dates = [...feasible.keys()].sort().slice(0, MAX_OPTIONS);
  const keep  = select.value;
  select.innerHTML = '';
  const ph = document.createElement('option');
  ph.value = ''; ph.disabled = true;
  ph.textContent = dates.length ? 'Select a delivery date' : 'No dates available — please contact us';
  select.appendChild(ph);
  dates.forEach(d => {
    const o = document.createElement('option');
    o.value = d; o.textContent = formatOption(d);
    select.appendChild(o);
  });
  if (keep && dates.includes(keep)) select.value = keep; else ph.selected = true;
  return dates;
}

function initInput(select) {
  const errorEl = document.getElementById(select.id + '-error');
  fillOptions(select, buildFeasibleDeliveries());

  function validate() {
    const val = select.value;
    if (!val) {
      select.setCustomValidity('Please select a delivery date.');
      if (errorEl) errorEl.textContent = '';
      return;
    }
    // Una pestaña abierta desde antes del corte puede tener una fecha que ya no se alcanza.
    const feasible = buildFeasibleDeliveries();
    if (feasible.has(val)) {
      select.setCustomValidity(''); if (errorEl) errorEl.textContent = '';
      return;
    }
    fillOptions(select, feasible);
    const msg = 'That date is no longer available. Please choose another one.';
    select.setCustomValidity(msg);
    if (errorEl) errorEl.textContent = msg;
  }

  select.addEventListener('change', validate);
  // Re-chequea al enviar: si la página llevaba horas abierta, el corte pudo pasar.
  if (select.form) select.form.addEventListener('submit', validate, true);
  validate();
  if (errorEl && !select.value) errorEl.textContent = '';
}

function initAll() {
  document.querySelectorAll('.delivery-date__input:not([data-dp-init])').forEach(input => {
    input.dataset.dpInit = '1';
    initInput(input);
  });
}

// Cargar capacidad primero, luego inicializar inputs
loadCapacity().then(initAll);
new MutationObserver(initAll).observe(document.body, { childList:true, subtree:true });
